import React from 'react';

const DEFAULT_CONNECTOR_CLASS_NAME = 'hidden items-center justify-center xl:flex';

type StepFlowGridProps<T> = {
  items: T[];
  getKey: (item: T) => React.Key;
  gridClassName: string;
  renderItem: (item: T, index: number) => React.ReactNode;
  connectorClassName?: string;
};

/**
 * Shared marketing step-flow layout: cards in a responsive grid with arrow
 * connectors that only appear once there is enough horizontal room.
 */
export const StepFlowGrid = <T,>({
  items,
  getKey,
  gridClassName,
  renderItem,
  connectorClassName = DEFAULT_CONNECTOR_CLASS_NAME,
}: StepFlowGridProps<T>) => (
  <div className={`grid gap-4 ${gridClassName}`}>
    {items.map((item, index) => (
      <React.Fragment key={getKey(item)}>
        {renderItem(item, index)}

        {index < items.length - 1 ? (
          <div className={connectorClassName} aria-hidden="true">
            <span className="h-px w-10 bg-[#d8b08f]" />
            <span className="ml-2 inline-flex h-8 w-8 items-center justify-center rounded-full border border-[#e1b78f] bg-white text-brand-primary">
              →
            </span>
          </div>
        ) : null}
      </React.Fragment>
    ))}
  </div>
);

export default StepFlowGrid;
